// extracted by mini-css-extract-plugin
export default {"statistics":"Statistics_statistics__MHVAH","title":"Statistics_title__eCJPs","statlist":"Statistics_statlist__Zw-bs","item":"Statistics_item__5jALf"};